module.exports = __webpack_public_path__ + "img/athena_carousel_11.5fce7329.jpg";